import * as echarts from "echarts";
declare let BMap: any;
export default class echartsLayer {
  private _map: any;
  private _div: any;
  private _point: any;
  private view: any;
  private box: any;
  private chart: any;
  private visible = true;
  private chartOption: any;
  private map_rotationChange_Listener: any;
  private map_extentChange_Listener: any;
  private map_extentChange_Listener1: any;

  constructor(view: any, option?: any) {
    this.init(view, option);
  }
  private async init(view: any, option: any) {
    let cordsys = this.getE3CoordinateSystem(view);
    echarts.registerCoordinateSystem("bmap", cordsys);

    this.setBaseMap(view);
    this.createLayer();
  }
  /*创建layer的容器，添加到map的layers下面*/
  private createLayer() {
    this.visible = true;
    let box = (this.box = document.createElement("div"));
    box.setAttribute("id", "echartsData");
    box.setAttribute("name", "echartsData");
    box.style.width = this.view.width + "px";
    box.style.height = this.view.height + "px";
    box.style.position = "absolute";
    box.style.top = "0px";
    box.style.left = "0px";
    box.style.zIndex = "99999999";
    // let parent = this.view.W.R.children[0].children[0];
    let parent: any;
    if (this.view.maskLayer) {
      parent = this.view.maskLayer;
    } else {
      parent = this.view.W.R.children[0].children[0];
      // parent = this.view.W.R.children[0].children[1].lastChild;
    }
    parent.appendChild(box);
    this.chart = echarts.init(box);
    this._div = box;
    this.startMapEventListeners();
  }
  /*销毁实例*/
  public removeLayer() {
    this.visible = false;
    this.box.outerHTML = "";
    this.view = null;
    this.box = null;
    this.chart = null;
    this.chartOption = null;
  }
  public async setChartOption(option: any) {
    this.chartOption = option;
    this.setCharts();
  }
  /*监听地图事件，根据图层是否显示，判断是否重绘echarts*/
  private startMapEventListeners() {
    let view = this.view;
    let _this = this;
    this.map_extentChange_Listener = view.addEventListener("dragging", (e: any) => {
      if (!_this.visible) return;
      _this.setCharts();
      _this.chart.resize();
    });
    this.map_rotationChange_Listener = view.addEventListener("zoomend", (e: any) => {
      if (!_this.visible) return;
      _this.setCharts();
      _this.chart.resize();
    });
    this.map_extentChange_Listener1 = view.addEventListener("moveend", (e: any) => {
      if (!_this.visible) return;

      _this.setCharts();
      _this.chart.resize();
    });
  }
  private setCharts() {
    if (!this.visible) return;
    if (this.chartOption == null || this.chartOption == "undefined" || this.view == undefined) return;
    let _this = this;
    this.chartOption.series.forEach((serie: any) => {
      if (serie.markPoint) {
        let mpData = serie.markPoint.data;
        serie.markPoint.data = mpData.map((dt: any) => {
          if (!dt.ox) {
            dt.ox = dt.x;
            dt.oy = dt.y;
          }
          var point = new BMap.Point(dt.x, dt.y);
          let px = this.view.pointToPixel(point);
          dt.x = px.x;
          dt.y = px.y;
          return dt;
        });
      }
    }, this);
    //判断是否使用了mark类型标签，每次重绘要重新转换地理坐标到屏幕坐标
    //根据地图extent,重绘echarts
    this.chartOption.xAxis = {
      show: false,
    };
    this.chartOption.yAxis = {
      show: false,
    };
    this.chartOption.animation = false;
    this.chart.setOption(this.chartOption);
  }
  private setBaseMap(view: any) {
    this.view = view;
  }
  private getE3CoordinateSystem(map: any) {
    let _map: any;
    let _mapOffset: any;
    let CoordSystem: any = function (map: any) {
      _map = map;
      _mapOffset = [0, 0];
    };
    CoordSystem.create = (ecModel: any) => {
      ecModel.eachSeries((seriesModel: any) => {
        if (seriesModel.get("coordinateSystem") === "bmap") {
          seriesModel.coordinateSystem = new CoordSystem(map);
        }
      });
    };
    CoordSystem.getDimensionsInfo = () => {
      return ["x", "y"];
    };
    CoordSystem.dimensions = ["x", "y"];
    CoordSystem.prototype.dimensions = ["x", "y"];
    CoordSystem.prototype.setMapOffset = (mapOffset: any) => {
      _mapOffset = mapOffset;
    };
    let _this = this;
    CoordSystem.prototype.dataToPoint = (data: any) => {
      var point = new BMap.Point(data[0], data[1]);
      var mapOffset = [0, 0];
      let px = this.view.pointToPixel(point);
      if (point) {
        return [px.x - mapOffset[0], px.y - mapOffset[1]];
      } else {
        return [0, 0];
      }
    };
    CoordSystem.prototype.pointToData = (pt: any) => {
      var mapOffset = _mapOffset;
      var screentPoint = {
        x: pt[0] + mapOffset[0],
        y: pt[1] + mapOffset[1],
      };
      var data = map.toMap(screentPoint);
      return [data.x, data.y];
    };
    CoordSystem.prototype.getViewRect = () => {
      //return new graphic.BoundingRect(0, 0, _map.width, _map.height);
    };
    CoordSystem.prototype.getRoamTransform = () => {
      //return matrix.create();
    };
    // CoordSystem.prototype.getOtherAxis = () => {
    //   //return matrix.create();
    // };

    return CoordSystem;
  }
}
